<template>
    <div>
    <iframe id="iframeTemp" ref="iframeTemp" style="display:none" width="0" body="0"></iframe>
                        
        <b-modal :no-close-on-backdrop="true" :size="(modals.escalation.is_use_edit_email_editor || modals.escalation.is_use_edit_sms_editor) ? 'xl' : ''" :dialog-class="(modals.escalation.is_use_edit_email_editor || modals.escalation.is_use_edit_sms_editor) ? 'popup-width-per-100' : ''" id="modal-Create" :title="modals.escalation.title" hide-footer :centered="true" v-model="open">
            <div v-bind:class="{'run-loading small-loading':modals.escalation.loading_content}">
                <b-form class="mb-4">
                    <b-row>
                        <b-col :md="(modals.escalation.is_use_edit_email_editor || modals.escalation.is_use_edit_sms_editor) ? 4 : 12" :class="{ 'border-right': (modals.escalation.is_use_edit_email_editor || modals.escalation.is_use_edit_sms_editor) }">
                            <b-row align-v="center">
                                <b-col md="5">
                                    <gofix-form-input-date
                                        label="Action Date"
                                        popoverDirection="top"
                                        :disabled="modals.escalation.data.action && modals.escalation.data.action.reference_value_abbr && modals.escalation.data.action.reference_value_abbr == 'nlt-close-a-case'"
                                        :required="true"
                                        :show-icon-required="true"
                                        v-model="modals.escalation.data.date" >
                                    </gofix-form-input-date>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-input-time
                                        label="Action Time"
                                        popoverDirection="top"
                                        :disabled="modals.escalation.data.action && modals.escalation.data.action.reference_value_abbr && modals.escalation.data.action.reference_value_abbr == 'nlt-close-a-case'"
                                        :required="true"
                                        :show-icon-required="true"
                                        v-model="modals.escalation.data.time" >
                                    </gofix-form-input-time>
                                </b-col>
                                <b-col md="3">
                                    <!--  @click="emailSendItems" -->
                                    <div class="action actionFloat actionFloat__extra d-flex font-weight-bold">
                                        <b-button type="button" :disabled="modals.escalation.is_disabled || !modals.escalation.is_disabled_sms" @click="showForm('is_use_edit_sms_editor')" class="pl-0 btnToggleEmail mr-3" :class="{'active': modals.escalation.is_use_edit_sms_editor}">
                                            <i class="fa fa-commenting-o" aria-hidden="true"></i>
                                        </b-button>
                                        <b-button type="button" :disabled="modals.escalation.is_disabled || !modals.escalation.is_disabled_email" @click="showForm('is_use_edit_email_editor')" class="pl-0 btnToggleEmail" :class="{'active': modals.escalation.is_use_edit_email_editor}">
                                            <i class="fa fa-envelope-o" aria-hidden="true"></i>
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <gofix-form-dropdown
                                            label="Actor"
                                            desc="Search by email"
                                            vLabel="user_name"
                                            @search="searchUser"
                                            :filterable="false"
                                            :required="true"
                                            :show-icon-required="true"
                                            v-model="officerName"
                                            :options="fmOfficer">
                                        <template slot="gofixInput:dropdown:option"  slot-scope="option">
                                            {{option.user_name}} - {{option.user_email}}
                                        </template>
                                        <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
                                            {{option.user_name}} - {{option.user_email}}
                                        </template>
                                    </gofix-form-dropdown>
                                    <gofix-form-dropdown
                                        label="Activity"
                                        :clearable="true"
                                        :show-icon-required="true"
                                        vLabel="reference_value_text"
                                        v-model="modals.escalation.data.action"
                                        :required="true"
                                        :options="actionType">
                                    </gofix-form-dropdown>
                                    <gofix-form-input-textarea :show-icon-required="true" label="Remark" :required="true" v-model="modals.escalation.data.remark"></gofix-form-input-textarea>
                                </b-col>
                                <b-col md="12" class="mb-3">
                                    <b-form-checkbox v-model="modals.escalation.data.is_change_case_status" class="ml-3 d-inline-block"><span class="ml-2">Change case status</span></b-form-checkbox>
                                </b-col>
                                <b-col md="12" class="mb-3" v-if="!modals.escalation.is_disabled">
                                    <b-form-checkbox v-model="modals.escalation.data.is_send_email" class="ml-3 d-inline-block"><span class="ml-2">Send email</span></b-form-checkbox>
                                </b-col>
                                <b-col md="12" class="mb-3" v-if="!modals.escalation.is_disabled">
                                    <b-form-checkbox v-model="modals.escalation.data.is_send_sms" class="ml-3 d-inline-block"><span class="ml-2">SMS</span></b-form-checkbox>
                                </b-col>
                                <!-- <b-col md="12" class="mb-3" v-if="!modals.escalation.is_disabled">
                                    <b-form-checkbox v-model="modals.escalation.data.is_push_noti" class="ml-3 d-inline-block"><span class="ml-2">Push Noti</span></b-form-checkbox>
                                </b-col>     -->
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <b-row class="mb-3">
                                        <div class="action actionFloat actionFloat__extra d-flex font-weight-bold">
                                            <div class="title pl-15">Attachments</div>
                                            <b-button @click="deleteAttachment" v-if="modals.escalation.attachmentDeleteId.length">
                                                <div class="tooltip">Delete</div>
                                                <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                                </svg>
                                            </b-button>
                                            <b-button type="button" @click="modals.attachment.open = true">
                                                <div class="tooltip">Create</div>
                                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                                </svg>
                                            </b-button>
                                        </div>
                                    </b-row>
                                    <b-row>
                                        <b-col class="col-6 mb-3" v-for="(attachment,index) in modals.escalation.attachments" :key="index">
                                            <div class="attachmentInfo">
                                                <div class="checkbox">
                                                    <b-form-checkbox class="uniform" :value="index" v-model="modals.escalation.attachmentDeleteId"></b-form-checkbox>
                                                </div>
                                                <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                                <div class="name">{{attachment.image_file_title || attachment.image_file_name}}</div>
                                            </div>
                                        </b-col>
                                        <b-col class="col-6 mb-3" v-for="(attachment,index) in modals.escalation.attachment_tmp.add" :key="'tmp'+index">
                                            <div class="attachmentInfo">
                                                <div class="checkbox">
                                                    <b-form-checkbox class="uniform" :value="'tmp'+index" v-model="modals.escalation.attachmentDeleteId"></b-form-checkbox>
                                                </div>
                                                <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                                <div class="name">{{attachment.image_file_title || attachment.name}}</div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="8" v-if="modals.escalation.is_use_edit_email_editor">
                            
                            <gofix-form-dropdown
                                label="From"
                                :show-icon-required="true"
                                :clearable="false"
                                vLabel="title"
                                v-model="modals.escalation.data.from"
                                @change="fromSelectionChange"
                                :required="true"
                                :options="modals.escalation.data.from_list">
                            </gofix-form-dropdown>
                            <!-- <gofix-form-input label="From" v-model="modals.escalation.data.from" :disabled="true"></gofix-form-input> -->
                            <gofix-form-input label="To" v-model="modals.escalation.data.to" :required="modals.escalation.data.is_send_email ? true : false" :show-icon-required="modals.escalation.data.is_send_email ? true : false"  :error="modals.escalation.data.to_invalid"></gofix-form-input>
                            <gofix-form-input label="CC" v-model="modals.escalation.data.cc" :error="modals.escalation.data.cc_invalid"></gofix-form-input>
                            <gofix-form-input label="Subject" v-model="modals.escalation.data.subject"></gofix-form-input>
                            <!-- <editor
                                api-key="il3ub5ilogli9992n1eqrbnx9cond36i0lhx8n8i4xj9v1bo"
                                :init="editorInit"
                                ref="editorEmail"
                            /> -->
                            <TinymceEditor :init="editorInit" ref="editorEmail"/>
                            <!-- v-model="modals.escalation.data.body" -->
                        </b-col>
                        <b-col md="7" v-if="modals.escalation.is_use_edit_sms_editor">
                            <gofix-form-dropdown
                                label="Select SMS template"
                                :clearable="true"
                                :show-icon-required="true"
                                vLabel="title"
                                v-model="modals.sms_template"
                                @change="changeSMSTemplate"
                                :required="true"
                                :options="smsTemplateOptions">
                            </gofix-form-dropdown>
                            <gofix-form-input-number label="To" v-model="modals.escalation.data.phone_number_sms" prefix="+" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false" :show-icon-required="modals.escalation.data.is_send_sms ? true : false"  :required="modals.escalation.data.is_send_sms ? true : false" class="gofixInputNoMinWidth" />
                            <gofix-form-input-textarea :show-icon-required="modals.escalation.data.is_send_sms ? true : false" :rows="15" label="Content" :required="modals.escalation.data.is_send_sms ? true : false" v-model="modals.escalation.data.messages_sms"></gofix-form-input-textarea>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right" >
                    <!-- sendMail -->
                    <gofix-button class="ml-4" label="SUBMIT" :loading="modals.escalation.loading" noBorder @click="showModalConfirm"></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.closeCase.open">
            <div class="center">Do you want to close <strong>this case</strong>?<br>This cannot be undone. The case will be locked, no more change or addition of activity.</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.closeCase.open = false">Cancel</b-button>
                <b-button class="custom-btn" :disabled="modals.closeCase.loading" @click="closeCase"> <b-spinner v-if="modals.closeCase.loading" small type="grow"></b-spinner> Confirm</b-button>
            </b-button-group>
        </b-modal>

         <b-modal :no-close-on-backdrop="true" id="modal-Remove" modal-class="modal-confirm-send-mail" hide-footer hide-header :centered="true" v-model="modals.confirmSendMail.open">
            <div class="center">
                Have you checked your work and ensure:<br>
                <ul>
                    <li>Confidential information, [etc: ORI, KSF] are accurate?</li>
                    <li>You are sending to the right party?</li>
                </ul>
                Once the email had been sent out, it cannot be recalled.
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="closeModalConfirmCancel">Cancel</b-button>
                <b-button class="custom-btn" :disabled="modals.confirmSendMail.loading" @click="sendMail">
                    <b-spinner v-if="modals.confirmSendMail.loading" type="grow" small></b-spinner> Confirm
                </b-button>
            </b-button-group>
        </b-modal>
        <!--File form-->
        <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" hide-footer v-model="modals.attachment.open">
                <b-form class="formV2">
                    <gofix-form-input label="File Title" v-model="modals.attachment.image_file_title"></gofix-form-input>
                    <b-form-group :label="modals.attachment.filename">
                        <b-form-file ref="file-input" v-model="modals.attachment.fileAttachment" ></b-form-file>
                    </b-form-group>
                    <b-button-group class="text-right d-block">
                        <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modals.attachment.loading"></gofix-button>
                    </b-button-group>
                </b-form>
            </b-modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
// import Editor from '@tinymce/tinymce-vue';
import TinymceEditor from '@/views/plugins/Editor.vue'
import moment from 'moment';

let emailSignature = ``;

var  com_email_body=null;
var com_just_confirmation_cancel = false;

export default {
    name: 'escalation',
    components: {
        // 'editor': Editor,
        TinymceEditor
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        nltAction: {
            type: Object,
            default: () => {}
        },
        email: {
            type: Object,
            default: () => {}
        },
        
    },
    data() {
        return {
            open: false,
            modals: {
                escalation:{
                    loading:false,
                    loading_content:false,
                    is_disabled: false,
                    is_use_edit_email_editor: false,
                    is_use_edit_sms_editor: false,
                    is_disabled_sms: false,
                    is_disabled_email: false,
                    data:{
                        caseId: this.$route.params.id,
                        reply:true,
                        src_identifier:'',
                        from:null,
                        from_list:null,
                        to:null,
                        to_tmp:null,
                        cc:null,
                        subject:null,
                        body:null,
                        body_tmp:null,
                        textarea:null,
                        remark: null,
                        date:null,
                        time:null,
                        time_stamp:null,
                        actor:null,
                        actor_id:null,
                        action:null,
                        log_type:'Manual',
                        is_send_email: false,
                        is_change_case_status: true,
                        is_send_sms: false,
                        to_invalid: false,
                        cc_invalid: false,
                        // is_push_noti: false
                    },
                    attachments: [],
                    attachmentUpdate: [],
                    attachmentDeleteId: [],
                    attachment_tmp: {
                        delete: [],
                        add:[],
                        update: []
                    },
                    editorOption: {
                        theme: 'snow',
                        modules: {
                            toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            [{ 'indent': '-1'}, { 'indent': '+1' }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                            ['link'],
                            ]
                        }
                    },
                    isResetData: true,

                },
                closeCase: {
                    open: false,
                    loading: false
                },
                attachment: {
                    open:false,
                    loading: false,
                    filename: "Click Browse to upload file",
                    fileAttachment:null,
                    image_file_title: '',
                    id: 0,
                    index: '',
                    edit: 0
                },
                sms_template:{
                    title:null
                },
                confirmSendMail: {
                    open: false,
                    loading: false
                }
            },
            timer: {
                escalation: null,
                confirmSend: null
            },
            editorInit: {
                height: 500,
                menubar: false,
                // entity_encoding : "raw",
                // verify_html : false,
                // inline: true,
                content_style: 'body { font-family: arial,sans-serif; font-size: 11pt; }',
                font_formats: 'Arial=arial',
                fontsize_formats: '11pt',
                plugins: [
                'advlist autolink lists link  charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help ',
                'table emoticons template paste help'
                ],
                toolbar:
                    'formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    table  \
                    bullist numlist outdent indent | removeformat | help',
                paste_data_images: true,
                setup : function(ed)
                {
                    ed.on('init', function() 
                    {
                        ed.execCommand("fontName", false, "Arial");
                        ed.execCommand("fontSize", false, "50");
                        if(com_just_confirmation_cancel){
                            tinymce.activeEditor.setContent(com_email_body);
                        }
                    });
                },
            },
            smsTemplateOptions:[],
            attachments: [],
            attachmentUpdate: [],
            attachmentDeleteId: [],
            attachment_tmp: {
                delete: [],
                add:[],
                update: []
            },
            actionType:[],
            officerName:null,
            fmOfficer:[],
            icons: {
                'application': {
                    'word': {
                        'img': 'word.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094ZM9.28301 8.29688H8.71699C8.62031 8.29688 8.53594 8.36191 8.51309 8.45684L7.63945 11.9531L6.8291 8.46035C6.80625 8.36543 6.72187 8.29688 6.62344 8.29688H6.00117C5.96884 8.29693 5.93695 8.3044 5.90795 8.31871C5.87896 8.33303 5.85364 8.3538 5.83395 8.37945C5.81425 8.40509 5.8007 8.43491 5.79434 8.46661C5.78798 8.49831 5.78898 8.53105 5.79727 8.5623L7.10156 13.4139C7.12617 13.5053 7.21055 13.5703 7.30547 13.5703H7.86797C7.96289 13.5703 8.04727 13.507 8.07188 13.4139L9 9.95098L9.92812 13.4139C9.95273 13.5053 10.0371 13.5703 10.132 13.5703H10.691C10.7859 13.5703 10.8703 13.507 10.8949 13.4139L12.2027 8.5623C12.2109 8.53105 12.2119 8.49834 12.2055 8.46667C12.1991 8.43499 12.1856 8.4052 12.1659 8.37958C12.1462 8.35396 12.1209 8.33318 12.0919 8.31885C12.063 8.30451 12.0311 8.29699 11.9988 8.29688H11.373C11.2746 8.29688 11.1902 8.36543 11.1674 8.46035L10.3623 11.9602L9.48691 8.45684C9.46406 8.36191 9.37969 8.29688 9.28301 8.29688Z" fill="#666666"/></svg>'
                    },
                    'excel': {
                        'img': 'excel.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM12.0492 13.5961L10.6008 11.1961C10.5492 11.1117 10.4578 11.0602 10.3594 11.0602H9.45938C9.40547 11.0602 9.35391 11.0742 9.30938 11.1047C9.17813 11.1867 9.13828 11.3602 9.22266 11.4937L11.1516 14.55L9.19687 17.6625C9.17032 17.7052 9.15565 17.7542 9.15438 17.8045C9.15312 17.8547 9.1653 17.9044 9.18968 17.9484C9.21405 17.9923 9.24973 18.029 9.29303 18.0546C9.33632 18.0801 9.38566 18.0937 9.43594 18.0938H10.2445C10.343 18.0938 10.432 18.0422 10.4836 17.9602L11.9531 15.5812L13.4133 17.9578C13.4648 18.0422 13.5562 18.0914 13.6523 18.0914H14.5312C14.5852 18.0914 14.6367 18.075 14.6836 18.0469C14.8148 17.9625 14.8523 17.7891 14.768 17.6578L12.7992 14.6016L14.7984 11.4961C14.8255 11.4535 14.8407 11.4045 14.8423 11.3541C14.844 11.3037 14.8322 11.2537 14.808 11.2095C14.7838 11.1652 14.7482 11.1282 14.7049 11.1024C14.6616 11.0765 14.6122 11.0628 14.5617 11.0625H13.725C13.6266 11.0625 13.5352 11.1141 13.4836 11.1984L12.0492 13.5961Z" fill="#666666"/></svg>'
                    },
                    'pdf': {
                        'img': 'pdf.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29688 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                    },
                    'text': {
                        'img': 'notepad.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
                    },
                },
                'image': {
                    'img': 'image.png',
                    'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72246 8.94902L8.35488 10.6928L7.63242 9.77168C7.61927 9.75487 7.60246 9.74128 7.58327 9.73193C7.56409 9.72258 7.54302 9.71772 7.52168 9.71772C7.50034 9.71772 7.47927 9.72258 7.46009 9.73193C7.4409 9.74128 7.42409 9.75487 7.41094 9.77168L5.65664 12.0076C5.64041 12.0283 5.63034 12.0532 5.62758 12.0794C5.62482 12.1056 5.62948 12.132 5.64104 12.1557C5.65259 12.1793 5.67056 12.1992 5.69291 12.2132C5.71525 12.2271 5.74106 12.2344 5.76738 12.2344H12.2344C12.3521 12.2344 12.4172 12.099 12.3451 12.0076L9.9457 8.94902C9.93237 8.93219 9.91541 8.91859 9.89608 8.90924C9.87675 8.89989 9.85555 8.89503 9.83408 8.89503C9.81261 8.89503 9.79142 8.89989 9.77209 8.90924C9.75276 8.91859 9.73579 8.93219 9.72246 8.94902ZM6.32812 7.76953C6.32812 7.95601 6.4022 8.13485 6.53407 8.26672C6.66593 8.39858 6.84477 8.47266 7.03125 8.47266C7.21773 8.47266 7.39657 8.39858 7.52843 8.26672C7.6603 8.13485 7.73438 7.95601 7.73438 7.76953C7.73438 7.58305 7.6603 7.40421 7.52843 7.27235C7.39657 7.14049 7.21773 7.06641 7.03125 7.06641C6.84477 7.06641 6.66593 7.14049 6.53407 7.27235C6.4022 7.40421 6.32812 7.58305 6.32812 7.76953ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                },
                'text': {
                    'img': 'notepad.png',
                    'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
                },
                'inode': 'none'
            },
        }
    },
    computed: {
        ...mapGetters({
            UserLogin: "AuthController/user",
            ClientContractID: 'ContractController/ClientContractID',
            Item: "CaseManagementController/Item",
        })
    },
    filters: {
        iconFile(val, icons, is_svg = false) {
                let path = 'img/';
                let type_show = 'img';
                let extension = '';
                let name = val.image_file_name || val.name;
                let type = val.type || val.image_content_type;

                if(is_svg) {
                    path = '';
                    type_show = 'svg';
                }
                if(val.type) extension = name.split('.')[1];

                let arrTemp = type.split('/');
                if(arrTemp && arrTemp.length == 2) {
                    let type = arrTemp[0];
                    if(!extension) extension = arrTemp[1];

                    if(type == 'application' || type == 'inode' || type == 'text') {
                        let key = 'pdf';
                        if(['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                        if(['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                        if(['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {
                            let extension = name.split('.')[1];
                            if(['doc', 'docx'].includes(extension)) key = 'word';
                            if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                            if(['txt'].includes(extension)) key = 'text';
                        }
                        return `${path}${icons['application'][key][type_show]}`;
                    }

                    return `${path}${icons[type][type_show]}`;
                }
            }
    },
    watch: {
        value: function (val) {
            if(val && this.modals.escalation.isResetData) {
                this.getUsers();
                this.getCaseActivityOptions();
                this.attachments = [];
                this.attachmentUpdate = [];
                this.attachmentDeleteId = [];
                this.attachment_tmp = {
                    delete: [],
                    add:[],
                    update: []
                };

                this.modals.escalation.title = this.nltAction.label;
                this.modals.escalation.data.date = moment().toDate();
                this.modals.escalation.data.time = moment().format("HH:mm");
                this.modals.escalation.data.remark = null;
                this.modals.escalation.data.is_send_email = false;
                this.modals.escalation.data.is_change_case_status = true;
                this.modals.escalation.data.is_send_sms = false;
                // this.modals.escalation.data.is_push_noti = false;
                this.officerName = {
                    user_id: this.UserLogin.id,
                    user_name: this.UserLogin.name,
                    user_email: this.UserLogin.email
                };

                this.modals.escalation.data.to      = null;
                this.modals.escalation.data.cc      = null;
                this.modals.escalation.data.subject = null;
                this.modals.escalation.data.body    = null;
                this.modals.escalation.data.action  = null;
                // if(this.nltAction.value) {
                //     if(['nlt-reply-to-eu-fcr', 'nlt-reply-to-eu-first-nfcr', 'nlt-reply-to-eu-interim', 'nlt-reply-to-eu-final-nfcr', 'nlt-escalate-to-stakeholder', 'nlt-1st-reminder', 'nlt-2nd-reminder', 'nlt-3rd-reminder', 'nlt-4th-reminder'].includes(this.nltAction.value)) {
                //         if(['nlt-reply-to-eu-fcr', 'nlt-reply-to-eu-first-nfcr', 'nlt-reply-to-eu-interim', 'nlt-reply-to-eu-final-nfcr'].includes(this.nltAction.value)) {
                //             this.modals.escalation.data.to = this.Item.case_requestor && this.Item.case_requestor.addresses && this.Item.case_requestor.addresses.email ? this.Item.case_requestor.addresses.email : null
                //         }

                //         let trigger_name = '';
                //         const priority = this.Item.sla && this.Item.sla.priority ? ` - ${this.Item.sla.priority}` : ''
                //         switch(this.nltAction.value) {
                //             case 'nlt-reply-to-eu-fcr':
                //                 trigger_name = `First reply to EU${priority}`;
                //                 break;
                //             case 'nlt-reply-to-eu-first-nfcr':
                //                 trigger_name = `First reply to EU${priority}`;
                //                 break;
                //             case 'nlt-reply-to-eu-interim':
                //                 trigger_name = `Interim reply to EU${priority}`;
                //                 break;
                //             case 'nlt-reply-to-eu-final-nfcr':
                //                 trigger_name = `Final reply to EU${priority}`;
                //                 break;
                //             case 'nlt-1st-reminder':
                //                 trigger_name = `Stakeholder 1st reminder${priority}`;
                //                 break;
                //             case 'nlt-2nd-reminder':
                //                 trigger_name = 'Stakeholder 2nd reminder';
                //                 break;
                //             case 'nlt-3rd-reminder':
                //                 trigger_name = 'Stakeholder 3rd reminder';
                //                 break;
                //             case 'nlt-4th-reminder':
                //                 trigger_name = 'Stakeholder 4th reminder';
                //                 break;
                //             default:
                //                 trigger_name = '';
                //         }

                //         if(trigger_name) this.loadEmailTemplate(trigger_name);

                //         if(['nlt-escalate-to-stakeholder','nlt-1st-reminder', 'nlt-2nd-reminder', 'nlt-3rd-reminder', 'nlt-4th-reminder'].includes(this.nltAction.value)) {
                //             this.loadEscalation();
                //         }

                //         this.modals.escalation.is_disabled = false;
                //         this.modals.escalation.is_use_edit_email_editor = true;
                //         this.modals.escalation.is_use_edit_sms_editor = false;
                //         this.modals.escalation.data.is_send_email = true;
                //         this.modals.escalation.data.is_send_sms = false;
                //     } else {
                //         this.modals.escalation.is_disabled = true;
                //         this.modals.escalation.is_use_edit_email_editor = false;
                //         this.modals.escalation.is_use_edit_sms_editor = false;
                //         this.modals.escalation.data.is_send_email = false;
                //         this.modals.escalation.data.is_send_sms = false;
                //     }
                // } else {
                    this.modals.escalation.is_disabled = false;
                    this.modals.escalation.is_use_edit_email_editor = true;
                    this.modals.escalation.is_use_edit_sms_editor = false;
                    this.modals.escalation.data.is_send_email = true;
                    this.modals.escalation.data.is_send_sms = false;
                //}
            } else this.modals.escalation.isResetData = true;
            this.open = val;
        },
       open: function (val) {
            if(val == true && this.modals.escalation.isResetData){

                this.loadEmailTemplate('Email Reply');

                this.modals.escalation.attachment_tmp.add = [];
                this.modals.escalation.data.from = '';
                if(typeof(this.email) !=='undefined')
                {
                    let params = Object.assign({
                        email_id: this.email.id
                    });

                    this.modals.escalation.loading_content = true;
                    this.$store.dispatch("EmailIntegrationController/EachEmail", params)
                    .then(response => {
                        this.email.body = response.data.data.body;
                        var toToAdd = "";
                        var arrCheck = ['cstl.stg@emservices.com.sg',
                                        'qp.stg@emservices.com.sg',
                                        'ask.stg@emservices.com.sg',
                                        'cstl@netlinknbn.com',
                                        'qpmail@netlinknbn.com',
                                        'ask@netlinknbn.com',
                                        'no-reply-staging-fm@gofix.com.sg',
                                        'no-reply-dev@gofix.com.sg',
                                        'no-reply-nlt@gofix.com.sg'];

                        var fromCheck = false;
                        
                        var emailCC = "";
                        if(this.email.cc){
                            emailCC = this.email.cc;
                        }

                        

                        for(var i=0;i<arrCheck.length;i++){
                            if(this.email.from.toLowerCase().includes(arrCheck[i])){
                                fromCheck = true;
                                break;
                            }

                        }
                        if(fromCheck)
                        {
                            this.modals.escalation.data.from = this.email.from.toLowerCase();
                            this.modals.escalation.data.from_list = [this.email.from.toLowerCase()];
                            this.modals.escalation.data.to=this.findAndRemoveEmails(this.email.to,'websupport@netlinknbn.com');
                            
                        }else
                        {
                            var checkTo = false;
                            let temp_from_list=[];
                            let emails_from;
                            
                            emails_from = this.email.from;
                            if(!emails_from.trim().endsWith(';'))
                            {
                                emails_from=this.email.from.trim()+";"
                            }

                            this.modals.escalation.data.to=this.findAndRemoveEmails(emails_from,'websupport@netlinknbn.com');
                            var toAddress = this.findAndRemoveEmails(this.email.to,'websupport@netlinknbn.com');

                            toAddress = this.checkAndCastToLowerCase(toAddress,arrCheck);

                            //assign into FROM from TO. need to lower case from email.

                            for(var i=0;i<arrCheck.length;i++){
                                if(toAddress && toAddress.includes(arrCheck[i])){
                                    temp_from_list.push(arrCheck[i]);

                                    if(toAddress.trim().split(';').length>1){
                                        toToAdd = this.findAndRemoveEmails(toAddress,arrCheck[i]);
                                        toAddress =toToAdd;
                                        this.modals.escalation.data.src_identifier="to";
                                    }
                                    checkTo= true;
                                }
                            }
                         
                            if(temp_from_list.length == 1)
                            {
                                this.modals.escalation.data.from = temp_from_list[0];
                            }
                            this.modals.escalation.data.from_list = temp_from_list;



                            var checkCC = false;
                            if(!checkTo){
                                // emailCC need to lower case cc email.
                                emailCC=this.checkAndCastToLowerCase(emailCC,arrCheck);
                                for(var i=0;i<arrCheck.length;i++){
                                    if(emailCC && emailCC.includes(arrCheck[i])){

                                        temp_from_list.push(arrCheck[i]);
                                        toToAdd = toAddress;
                                        emailCC= this.findAndRemoveEmails(emailCC,arrCheck[i]);
                                        checkCC= true;
                                        this.modals.escalation.data.src_identifier="cc";
                                        
                                    }
                                }

                                if(temp_from_list.length == 1)
                                {
                                    this.modals.escalation.data.from = temp_from_list[0];
                                }
                                this.modals.escalation.data.from_list = temp_from_list;
                                }
                        
                        }


                        if(toToAdd && toToAdd != ""){
                            if(this.modals.escalation.data.to.trim().endsWith(";")){
                                this.modals.escalation.data.to = this.modals.escalation.data.to + toToAdd;
                            }
                            else{
                                this.modals.escalation.data.to = this.modals.escalation.data.to + ';' + toToAdd;
                            }
                        }

                        if(emailCC != "")
                        {
                            this.modals.escalation.data.cc=this.findAndRemoveEmails(emailCC,'websupport@netlinknbn.com');       
                        }
                        

                        
                        if(this.email.subject &&  this.email.subject.toLowerCase().startsWith("re:"))
                        {
                            this.modals.escalation.data.subject = this.email.subject;
                        }else{
                            this.modals.escalation.data.subject = "RE: "+this.email.subject;
                        }
                        
                        if(!this.modals.escalation.data.subject.includes(this.Item.case_number))
                        {
                        this.modals.escalation.data.subject = this.modals.escalation.data.subject + " (Case Ref No: " + this.Item.case_number + ")";
                        }

                        
                        if(Object.keys(this.email)!==0 && this.modals.escalation.isResetData == true)
                        {
                            // each vars should null check .

                            if(typeof(this.email.from) !=='undefined' && typeof(this.email.subject) !=='undefined' && typeof(this.email.to) !=='undefined' && typeof(this.email.body) !=='undefined')
                            {
                                var escalation_data = "";
                                if(emailSignature == null)
                                {
                                    emailSignature='';
                                }
                                escalation_data = emailSignature.replace('[Agent name]',this.UserLogin.name);

                                escalation_data=escalation_data+"<p style='font-size: 11pt; font-family: arial'><br> <hr> <br>";
                                escalation_data=escalation_data+" From: <"+this.email.from+"> <br>";
                                if(this.email.received_time != null)
                                {
                                    let received_time=moment(this.email.received_time,'YYYY-MM-DD hh:mm:ss').format("dddd DD/MM/YYYY hh:mm A");
                                    escalation_data=escalation_data+" Sent: "+received_time+" <br>";
                                }else
                                {
                                    let received_time=moment(this.email.date,'DD/MM/YYYY hh:mm').format("dddd DD/MM/YYYY hh:mm A");
                                    escalation_data=escalation_data+" Sent: "+received_time+" <br>";
                                }
                                
                                
                                
                                escalation_data=escalation_data+" Subject: "+this.email.subject+" <br>";
                                escalation_data=escalation_data+" To: <"+this.email.to+"> <br>";
                                escalation_data=escalation_data+" "+this.getReplyBody(this.email.body)+" <br>  <hr> </p>";
                                this.modals.escalation.data.body = escalation_data;
                                this.clearIframeTemp();
                                com_email_body = escalation_data;
                                setTimeout(() => tinymce.activeEditor.setContent(com_email_body), 1000);
                            }
                            
                        }
                        this.modals.escalation.loading_content = false;
                })
                .catch(err => {
                    console.log(err);
                    this.modals.escalation.loading_content = false;
                    this.$alertNotification("Cannot load email detail", "danger");
                });

                }
                

           }
           else {
                
                if(!this.modals.confirmSendMail.open && !val)
                {
                    this.modals.escalation.data.from = '';
                }
                
    
           }

            this.$emit('input', val);
        },
        
        nltAction: function(val) {
        },
        "modals.attachment.fileAttachment": function(val, old) {
            this.modals.attachment.filename = 'Click Browse to upload file';
            if (val) {
                let extensionAccept = ['csv', 'pdf', 'txt', 'jpeg', 'jpg', 'png', 'gif','msg','html','htm','zip','eml'];
                let extensionArray = val.name.split('.');
                let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                if(!extensionAccept.includes(extension)) {
                    this.$refs['file-input'].reset()
                    return this.$alertNotification("File format is incorrect. Please select a .zip, .html, .msg, .csv, .pdf, .txt, .jpeg, .jpg, .png, .gif, .eml file!", "warning");
                }
                this.modals.attachment.filename = val.name
            }
        },
        "modals.attachment.open": function(val) {
            if(val == true) {
                this.resetFormImport();
            }
        },
        "modals.escalation.data.is_send_email": function(val) {
            this.modals.escalation.is_disabled_email = val;
            if(!this.modals.escalation.is_disabled_email) {
                this.modals.escalation.data.to = null;
                this.modals.escalation.data.cc = null;
                this.modals.escalation.data.subject = null;
                this.modals.escalation.data.body = '';
                this.modals.escalation.is_use_edit_email_editor = false;
            } else {
                if(this.modals.escalation.data.action) this.changeActivity(this.modals.escalation.data.action);
            }
        },
        "modals.escalation.data.is_send_sms": function(val) {
            this.modals.escalation.is_disabled_sms = val;
            if(!this.modals.escalation.is_disabled_sms) {
                this.modals.escalation.is_use_edit_sms_editor = false;
                this.modals.sms_template = null;
                this.modals.escalation.data.phone_number_sms = null;
                this.modals.escalation.data.messages_sms = null;
            }
        }
    },
    created() {
    },
    mounted(){
    },
    methods: {
        loadEscalation(){
            
            


            this.$store.dispatch("EscalationController/getItems", {
                page:1,
                limit:-1,
                filter:{
                  service_category_id:this.Item.service_category_id ? this.Item.service_category_id : 0,
                  property_id:this.Item.property_id ? this.Item.property_id : null,
                }
            }).then(response => {
               
            })
            .catch(err => {
                
            })
           
        },
        loadEmailTemplate(trigger_name) {
            this.$store.dispatch("NotificationTemplateController/getItems", {
                page:1,
                limit:1,
                filter:{
                    contract_id: this.Item.contract ? this.Item.contract.id : 0,
                    "notification_event_trigger.name": trigger_name
                },
                caseID: this.Item.id
            }).then(response => {
                // this.modals.escalation.data.subject = null
                this.modals.escalation.data.body = ''
                if(response.data.data.items){
                    let item = response.data.data.items[0]
                    // this.modals.escalation.data.subject = item && item.title ? item.title : null
                    emailSignature = item && item ? item.content : null
                }
            })
            .catch(err => {
                console.log(err)
                this.modals.escalation.data.subject = null
                this.modals.escalation.data.body = ''
                this.$alertNotification("Cannot Load Notification Template", "danger");
            })
        },
        sendMail(){
            com_just_confirmation_cancel = false;
            this.modals.escalation.data.to_invalid=false;
            this.modals.escalation.data.cc_invalid=false;

            if(!this.modals.escalation.data.date ||
                !this.modals.escalation.data.time ||
                !this.officerName ||
                !this.modals.escalation.data.action ||
                !this.modals.escalation.data.remark){
                return this.$alertNotification('Please enter all fields!', 'danger');
            }

            if(this.modals.escalation.data.is_send_email) {
                    if(!this.modals.escalation.data.to){
                        return this.$alertNotification("Email To is required", "danger");
                    }
                    else{
                        let result  = this.emailValidationCheckSemiColonMissingBetweenTwoEmails(this.modals.escalation.data.to);
                        if(!result){
                            this.modals.escalation.data.to_invalid=true;
                            return this.$alertNotification("Email To is not in a correct format. Semicolon ';' is missing between two or more emails. ", "danger");
                        }
                    }

                    let result  = this.emailValidationCheckSemiColonMissingBetweenTwoEmails(this.modals.escalation.data.cc);
                    if(!result){
                        this.modals.escalation.data.cc_invalid=true;
                        return this.$alertNotification("Email CC is not in a correct format. Semicolon ';' is missing between two or more emails. ", "danger");
                    }

                    if(!this.emailValidationCheckFormatMultipleAddresses(this.modals.escalation.data.to)){
                        this.modals.escalation.data.to_invalid=true;
                        return this.$alertNotification("Email To is not in a correct format.", "danger");
                    }

                    if(!this.emailValidationCheckFormatMultipleAddresses(this.modals.escalation.data.cc)){
                        this.modals.escalation.data.cc_invalid=true;
                        return this.$alertNotification("Email CC is not in a correct format.", "danger");
                    }

                }

           

            if(this.modals.escalation.loading == true) return;
            this.modals.escalation.loading = true

            this.modals.escalation.data.body = this.modals.escalation.data.body_tmp;
            this.modals.escalation.data.to = this.modals.escalation.data.to_tmp;
            // this.modals.escalation.data.body=this.modals.escalation.data.body;

            let request = Object.assign({}, this.modals.escalation.data);
            
            request.reply= this.modals.escalation.data.reply;
            request.from = this.modals.escalation.data.from;
            request.caseId = this.$route.params.id
            request.work_item_type = "Case";
            request.work_item_id = this.$route.params.id;
            request.attachments = this.modals.escalation.attachment_tmp.add;
            request.action = this.modals.escalation.data.action.reference_value_text;
            request.nlt_case_key_action = this.modals.escalation.data.action.reference_value_abbr ? this.modals.escalation.data.action.reference_value_abbr : null
            request.is_create_email = this.modals.escalation.data.is_send_email ? true : false
            request.nature_feedback = this.Item.nature_feedback && this.Item.nature_feedback.name ? this.Item.nature_feedback.name : ''
            if(request.body)
            {
               request.body = `<div style="font-family: arial,sans-serif; font-size: 11pt;">${request.body}</div>`
            }
            // delete request.textarea;

            if(this.officerName){
                request.actor_id = this.officerName.user_id;
                request.actor = this.officerName.user_name;
            }
            request.time_stamp = moment(request.date).format("YYYY-MM-DD") + ' ' + request.time;
            delete request['date'];
            delete request['time'];
            //if(this.nltAction) request.nlt_case_key_action = this.nltAction.value

            this.$store.dispatch("CaseManagementController/escalation", request)
                .then(response => {
                    this.open = false;
                    this.modals.escalation.loading = false
                    this.modals.confirmSendMail.open = false;
                    this.modals.escalation.open = false;
                    this.$emit('updateSuccess');
                    return this.$alertNotification(this.$notificationV2('editing', 'case'));
                })
                .catch(err => {
                    this.modals.escalation.loading = false;
                    this.modals.escalation.open = false;
                    console.log(err);
                    return this.$alertNotification('An error has occured!','danger');
                });
        },
        showModalConfirm()
        {
            if (this.timer.escalation) {
                clearTimeout(this.timer.escalation);
                this.timer.escalation = null;
            }

            this.timer.escalation = setTimeout(() => {
                this.modals.escalation.data.to_invalid=false;
                this.modals.escalation.data.cc_invalid=false;

                if(!this.modals.escalation.data.date ||
                    !this.modals.escalation.data.time ||
                    !this.officerName ||
                    !this.modals.escalation.data.action ||
                    !this.modals.escalation.data.remark || 
                    !this.modals.escalation.data.from)
                {
                    return this.$alertNotification('Please enter all fields!', 'danger');
                }

                if(this.modals.escalation.data.is_send_email) {



                    if(!this.modals.escalation.data.to){
                        return this.$alertNotification("Email To is required", "danger");
                    }
                    else{
                        this.modals.escalation.data.to=this.emailRemoveInvalidCharacters(this.modals.escalation.data.to);
                        let result  = this.emailValidationCheckSemiColonMissingBetweenTwoEmails(this.modals.escalation.data.to);
                        if(!result){
                            this.modals.escalation.data.to_invalid=true;
                            return this.$alertNotification("Email To is not in a correct format. Semicolon ';' is missing between two or more emails. ", "danger");
                        }
                    }

                    this.modals.escalation.data.cc=this.emailRemoveInvalidCharacters(this.modals.escalation.data.cc);
                    let result  = this.emailValidationCheckSemiColonMissingBetweenTwoEmails(this.modals.escalation.data.cc);
                    if(!result){
                        this.modals.escalation.data.cc_invalid=true;
                        return this.$alertNotification("Email CC is not in a correct format. Semicolon ';' is missing between two or more emails. ", "danger");
                    }

                    if(!this.emailValidationCheckFormatMultipleAddresses(this.modals.escalation.data.to)){
                        this.modals.escalation.data.to_invalid=true;
                        return this.$alertNotification("Email To is not in a correct format.", "danger");
                    }

                    if(!this.emailValidationCheckFormatMultipleAddresses(this.modals.escalation.data.cc)){
                        this.modals.escalation.data.cc_invalid=true;
                        return this.$alertNotification("Email CC is not in a correct format.", "danger");
                    }

                }

                this.modals.escalation.data.to_tmp = this.modals.escalation.data.to;
                this.modals.escalation.data.body_tmp = tinymce.activeEditor.getContent();
                tinymce.activeEditor.setContent('');

                if(!this.modals.escalation.data.is_send_email && !this.modals.escalation.data.is_send_sms) {
                    if(this.modals.escalation.loading) return;
                    this.modals.escalation.loading = true;
                    this.sendMail();
                    return;
                }



                this.open = false;
                this.modals.confirmSendMail.open = true;



            }, 200);

            // this.modals.confirmSendMail.open=true;
        },
         closeModalConfirmCancel() {
            this.modals.escalation.isResetData = false;
            this.modals.escalation.data.body = this.modals.escalation.data.body_tmp;
            com_email_body = this.modals.escalation.data.body_tmp;
            this.modals.confirmSendMail.open = false;
            com_just_confirmation_cancel = true;
            this.open = true;
        },
        closeCase() {
            this.modals.closeCase.loading = true;

            let request = Object.assign({}, this.modals.escalation.data);
            request.caseId = this.$route.params.id
            request.work_item_type = "Case";
            request.work_item_id = this.$route.params.id;
            request.attachments = this.modals.escalation.attachment_tmp.add;
            request.action = this.modals.escalation.data.action.reference_value_text;
            request.nlt_case_key_action = this.modals.escalation.data.action.reference_value_abbr ? this.modals.escalation.data.action.reference_value_abbr : null
            request.is_create_email = this.modals.escalation.data.is_send_email ? true : false
            if(this.officerName){
                request.actor_id = this.officerName.user_id;
                request.actor = this.officerName.user_name;
            }

            request.time_stamp = moment(request.date).format("YYYY-MM-DD") + ' ' + request.time;
            delete request['date'];
            delete request['time'];
            //if(this.nltAction) request.nlt_case_key_action = this.nltAction.value

            this.$store.dispatch("CaseManagementController/escalation", request)
            .then(response => {
                this.modals.closeCase.loading = false;
                this.modals.closeCase.open    = false;
                this.$alertNotification(this.$notificationV2('editing', 'case'));
                this.$emit('updateSuccess');
            })
            .catch(err => {
                this.modals.closeCase.loading = false;
            });
        },
        checkShowIcon(val) {
            if(!val) return false;
            let type = val.type || val.image_content_type;
            if(!type) return false;
            let arrTemp = type.split('/');
            if(!arrTemp || arrTemp.length < 2 || !this.icons[arrTemp[0]]) return false;
            return true;
        },
        deleteAttachment(){
            if(this.modals.escalation.attachmentDeleteId.length > 0){
                this.modals.escalation.attachmentDeleteId = this.modals.escalation.attachmentDeleteId.sort().reverse();
                for(let index of this.modals.escalation.attachmentDeleteId){
                    if( typeof(index) == "string" && index.includes("tmp")) {
                        index = index.slice(3);
                        this.modals.escalation.attachment_tmp.add.splice(index, 1);
                    }else {
                        let item = this.modals.escalation.attachments.splice(index, 1);
                        this.modals.escalation.attachment_tmp.delete.push(item[0])
                    }
                }
                this.modals.escalation.attachmentDeleteId.length = 0;
            }
        },
        async getCaseActivityOptions(){
            let filter = {reference_type: "Case Activity",contract_id: this.Item.contract && this.Item.contract.id };
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.actionType = response.items;
                    if(this.actionType.length && !this.modals.escalation.data.action && this.nltAction.value) {
                        let arrTmp = this.actionType.filter(item => item.reference_value_abbr == this.nltAction.value);
                        if(arrTmp.length) {
                            this.modals.escalation.data.action = arrTmp[0];
                            this.changeActivity(this.modals.escalation.data.action);
                        }
                    }
                })
        },
        async getUsers(){
            let filter = {user_name:{type:"text",value:"",function:"ilike",with:[]},user_email:{type:"text",value:"",function:"ilike",with:[]},user_type:{type:"text",value:"FM Officer",function:"ilike",with:[]},contract_id:{type:"number",value:this.Item.contract && this.Item.contract.id,function:"=",with:[]}};
            let request = {
                limit: 100,
                page: 1,
                isCMS:1,
                sortColumn:'user_id',
                sortDirection:'ASC',
                filter: filter,
                useDatabaseView:true
            };
            this.$store.dispatch("UserDutyController/getItems", request)
                .then(result=>{
                    this.fmOfficer = result.items;
                })
                .catch(err => {
                    console.log(err);
                })
        },
        async searchUser (search, loading){
            loading(true);
            if(this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            let filter = {user_name:{type:"text",value:'',function:"ilike",with:[]},user_email:{type:"text",value:search,function:"ilike",with:[]},user_type:{type:"text",value:"FM Officer",function:"ilike",with:[]},contract_id:{type:"number",value:this.Item.contract && this.Item.contract.id,function:"=",with:[]}};
            let request = {
                limit: 100,
                page: 1,
                isCMS:1,
                sortColumn:'user_id',
                sortDirection:'ASC',
                filter: filter,
                useDatabaseView:true
            };
            this.timer = setTimeout(() => {
                this.$store.dispatch("UserDutyController/getItems", request)
                    .then(response => {
                        this.fmOfficer = response.items;
                        loading(false)
                    })
                    .catch(err=>{ loading(false) })
            }, 500);
        },
        addAttachment(){
            if( this.modals.attachment.filename == 'Click Browse to upload file' && !this.modals.attachment.fileAttachment ) {
                return this.$alertNotification("Please select a file", "danger");
            }

            if(this.modals.attachment.index !== '') {
                if(this.modals.attachment.id != 0) {
                    if(this.modals.remark.attachments[this.modals.attachment.index]) {
                        this.modals.remark.attachments[this.modals.attachment.index].image_file_title = this.modals.attachment.image_file_title
                        this.modals.remark.attachments[this.modals.attachment.index].image_file_name = this.modals.attachment.fileAttachment ? this.modals.attachment.fileAttachment.name : this.modals.remark.attachments[this.modals.attachment.index].image_file_name
                        let index = this.modals.escalation.attachment_tmp.update.findIndex(item => item.id == this.modals.attachment.id)
                        if(index != -1) {
                            this.modals.escalation.attachment_tmp.update[index] = Object.assign(this.modals.escalation.attachment_tmp.update[index], {
                                image_file_title: this.modals.attachment.image_file_title,
                                attachment: this.modals.attachment.fileAttachment || this.modals.escalation.attachment_tmp.update[index].attachment
                            })
                        } else {
                            this.modals.escalation.attachment_tmp.update.push({
                                id: this.modals.attachment.id,
                                image_file_title: this.modals.attachment.image_file_title,
                                attachment: this.modals.attachment.fileAttachment
                            })
                        }
                    }
                } else {
                    let idx = this.modals.attachment.index.slice(3);
                    if(this.modals.escalation.attachment_tmp.add[idx]) {
                        this.modals.escalation.attachment_tmp.add[idx] = this.modals.escalation.attachment_tmp.add[idx] || this.modals.attachment.fileAttachment;
                        this.modals.escalation.attachment_tmp.add[idx].image_file_title = this.modals.attachment.image_file_title
                    }
                }
                this.$refs['modal-Import-attachments-edit'].hide();
            } else {
                //Add attachment
                this.modals.attachment.fileAttachment.image_file_title = this.modals.attachment.image_file_title;
                this.modals.escalation.attachment_tmp.add.push(this.modals.attachment.fileAttachment);
            }
            this.resetFormImport();
            this.modals.attachment.open = false;
        },
        resetFormImport() {
            this.modals.attachment.filename = 'Click Browse to upload file';
            this.modals.attachment.fileAttachment = null;
            this.modals.attachment.image_file_title = null;
            this.modals.attachment.id = 0;
            this.modals.attachment.index = '';
        },
        showForm(key) {
            this.modals.escalation.is_use_edit_email_editor = false;
            this.modals.escalation.is_use_edit_sms_editor = false;
            this.modals.escalation[key] = !this.modals.escalation[key]
            this.getSMSTemplate();
        },
        changeActivity(val) {
            if(val.reference_value_abbr) {
                if(['nlt-reply-to-eu-fcr', 'nlt-reply-to-eu-first-nfcr', 'nlt-reply-to-eu-interim', 'nlt-reply-to-eu-final-nfcr', 'nlt-escalate-to-stakeholder', 'nlt-1st-reminder', 'nlt-2nd-reminder', 'nlt-3rd-reminder', 'nlt-4th-reminder'].includes(val.reference_value_abbr)) {
                    let trigger_name = '';
                    const priority = this.Item.sla && this.Item.sla.priority ? ` - ${this.Item.sla.priority}` : ''
                    switch(val.reference_value_abbr) {
                        case 'nlt-reply-to-eu-fcr':
                            trigger_name = `First reply to EU${priority}`;
                            break;
                        case 'nlt-reply-to-eu-first-nfcr':
                            trigger_name = `First reply to EU${priority}`;
                            break;
                        case 'nlt-reply-to-eu-interim':
                            trigger_name = `Interim reply to EU${priority}`;
                            break;
                        case 'nlt-reply-to-eu-final-nfcr':
                            trigger_name = `Final reply to EU${priority}`;
                            break;
                        case 'nlt-1st-reminder':
                            trigger_name = `Stakeholder 1st reminder${priority}`;
                            break;
                        case 'nlt-2nd-reminder':
                            trigger_name = 'Stakeholder 2nd reminder';
                            break;
                        case 'nlt-3rd-reminder':
                            trigger_name = 'Stakeholder 3rd reminder';
                            break;
                        case 'nlt-4th-reminder':
                            trigger_name = 'Stakeholder 4th reminder';
                            break;
                        default:
                            trigger_name = '';
                    }

                    if(trigger_name) this.loadEmailTemplate(trigger_name);

                    if(['nlt-escalate-to-stakeholder','nlt-1st-reminder', 'nlt-2nd-reminder', 'nlt-3rd-reminder', 'nlt-4th-reminder'].includes(val.reference_value_abbr)) {
                        this.loadEscalation();
                    } 
                    // else {
                    //     // this.modals.escalation.data.to = this.Item.case_requestor && this.Item.case_requestor.addresses && this.Item.case_requestor.addresses.email ? this.Item.case_requestor.addresses.email : null
                    // }
                } 
                
                // else {
                //     this.modals.escalation.data.to = null
                //     this.modals.escalation.data.cc = null
                //     this.modals.escalation.data.subject = null
                //     this.modals.escalation.data.body = ''
                // }
            } 
            // else {
            //     this.modals.escalation.data.to = null
            //     this.modals.escalation.data.cc = null
            //     this.modals.escalation.data.subject = null
            //     this.modals.escalation.data.body = ''
            // }
        },
        async getSMSTemplate(){
            let tableRequest = {
                page:1,
                limit:25,
                filter:{
                    contract_id: this.Item.contract ? this.Item.contract.id : 0,
                    medium: "sms"
                }
            };
            await this.$store.dispatch("NotificationTemplateController/getItems", tableRequest)
                .then(response => {
                    this.smsTemplateOptions = response.data.data.items;
                })
                .catch(err => {
                    this.$alertNotification("Can not load list of notification templates", "danger");
                    reject();
                })
        },
        async changeSMSTemplate(){
            this.modals.escalation.data.messages_sms = this.modals.sms_template?this.modals.sms_template.content:'';
        },
        fromSelectionChange()
        {
            let exclude_from_list=[];
            let count = this.modals.escalation.data.from_list.length;

            if(count > 1)
            {
                exclude_from_list = this.modals.escalation.data.from_list.filter(el=>el!==this.modals.escalation.data.from);
                let exclude_from  = exclude_from_list.join("; ");

                if(this.modals.escalation.data.src_identifier=='to')
                {
                    // alert(this.modals.escalation.data.to);
                   
                
                    let from_list = this.modals.escalation.data.from_list;
                    let temp_to = this.modals.escalation.data.to;
                    
                    for (let i = 0; i <from_list.length; i++) {
                        temp_to=this.findAndRemoveEmails(temp_to,from_list[i]);
                    }
                    
                    this.modals.escalation.data.to = temp_to + exclude_from;

                }else if (this.modals.escalation.data.src_identifier=='cc')
                {  
                   
                    let from_list = this.modals.escalation.data.from_list;
                    let temp_cc = this.modals.escalation.data.cc;
                    
                    if(temp_cc != null)
                    {
                        for (let i = 0; i <from_list.length; i++) 
                        {
                            temp_cc=this.findAndRemoveEmails(temp_cc,from_list[i]);
                        }
                    }
                    else
                    {
                        temp_cc = '';
                    }
                    

                    this.modals.escalation.data.cc = temp_cc + exclude_from;
                }




            }
        },
        getReplyBody(body){
            var iframe = document.getElementById("iframeTemp");

            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(body!=null?body:"");
            iframe.contentWindow.document.close();
            var element = iframe.contentWindow.document.getElementsByTagName("body")[0];
            return element.innerHTML;
        },
        clearIframeTemp(){
            var iframe = document.getElementById("iframeTemp");
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(null);
            iframe.contentWindow.document.close();
        },
        checkAndCastToLowerCase(needle, haystack)
        {
            // need to check null or undefined.
            if(needle)
            {
                let tmp_str = '';
                let str= needle.toLowerCase();
                for(var i=0;i<haystack.length;i++){
                    if(str.includes(haystack[i]))
                    {
                        let searchMask = haystack[i];
                        let regEx = new RegExp(searchMask, "ig");
                        let replaceMask = haystack[i].toLowerCase();
                        needle = needle.replace(regEx, replaceMask);
                    }
                }
                
            }
            return needle;
            
        },
        // case sensitive working only.
        findAndRemoveEmails(email_addresses,remove_address){
            if(email_addresses){             
            let arr=[];
            arr.push(remove_address.trim());
            var result = "";
            let match="";
            if(email_addresses.includes(';'))
            {
                if(!email_addresses.endsWith(';')){
                    email_addresses = email_addresses + ";";
                }

                let arr1=email_addresses.split(';');
                arr1.some(element => {

                    let el=element.trim();
                    
                    if(arr.indexOf(el) !== -1)
                    {
                        match=el;
                    }                   
                });
                                
                if(match !=="")
                {
                    result=email_addresses.replace(match+";",'');
                }else
                {
                    result=email_addresses;
                }
                    
            }else
            {
                result= arr.includes(email_addresses)? "": email_addresses;
            }
            
            result = result.replace(/\s;/g, '');
            
            return result;
            }
            return email_addresses;
        },
        emailValidationCheckSemiColonMissingBetweenTwoEmails(mail_addr){
            let check = true;
            if(mail_addr){
                let pattern = /\@[^;]+\@/;
                let result  = pattern.test(mail_addr);
                if(result){
                    check = false;
                }
            }
            return check;
        },
        emailValidationCheckFormatMultipleAddresses(email_addresses){
            let result = true;
            if(email_addresses){
                email_addresses= email_addresses.trim();
                if(email_addresses.includes(';'))
                            {
                                let arr1=email_addresses.split(';');
                                for(var i=0; i<arr1.length; i++){
                                    var item = arr1[i].trim();
                                    
                                    if(!this.emailValidationCheckFormat(item)){
                                        result = false;
                                        break;
                                    }
                                }
                            }
                else {
                    result=this.emailValidationCheckFormat(email_addresses);
                }
            }
            return result;
        },
        emailValidationCheckFormat(email_address){
            if(email_address && email_address != ''){
                let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
                let result = pattern.test(email_address);
                return result;
            }
            return true;
        },
        emailRemoveInvalidCharacters(email_address){
            if(email_address){
                email_address=email_address.replace(/\s/g,''); //remove space
                email_address=email_address.replace(/^;+|;+/g, ';'); // remove consecutive ;;
                email_address=email_address.replace(/^;+/,''); // remove beginning ;
            }
            return email_address;
        },
    },
    beforeDestroy: function () {
    }
    
}
</script>
